// extracted by mini-css-extract-plugin
export var legendIndicator = "_dp-1";
export var legendRight = "_dp-0";